<template>
  <v-card elevation="0" tile :color="bg_color" class="mx-5">
    <v-container class="py-0">
      <v-row justify="center">
        <v-card elevation="0" tile class="px-0" width="1200" :color="bg_color">
          <v-fab-transition>
            <v-btn color="white" dark absolute top left fab :x-large="!isSmall">
              <v-icon :color="theme_color">{{ main_icon }}</v-icon>
            </v-btn>
          </v-fab-transition>
          <v-card-text>
            <v-list class="mb-10" :color="bg_color">
              <v-subheader class="px-0 mx-0 mt-5">
                <v-row justify="center" class="px-0 mx-0">
                  <v-col cols="4">
                    <span
                      :class="
                        isSmall
                          ? theme_text_color + ' subtitle-1'
                          : theme_text_color + ' title'
                      "
                    >
                      Education
                    </span>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="5">
                    <span class="subtitle-1"> Degree </span></v-col
                  >
                  <v-col cols="3">
                    <span class="subtitle-1"> Date </span></v-col
                  >
                </v-row></v-subheader
              >
              <v-list-item-group active-class="border" :color="theme_color">
                <v-list-item
                  v-for="(item, index) of edu"
                  :key="index"
                  class="pa-0"
                >
                  <v-row justify="center" class="px-0 mx-0">
                    <v-col lg="1" sm="2" align="center" class="px-0">
                      <v-avatar size="75">
                        <img :src="item.img" alt="John" />
                      </v-avatar>
                    </v-col>
                    <v-col v-if="!isExSmall" cols="3" align-self="center">
                      <span class="subtitle-1 font-weight-light">{{
                        item.name
                      }}</span>
                    </v-col>
                    <v-col lg="5" sm="4" align-self="center">
                      <span class="subtitle-1">{{ item.degree }}</span>
                    </v-col>
                    <v-col cols="3" align-self="center">
                      <span class="subtitle-1 font-weight-light">
                        {{ item.date }}</span
                      >
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
        </v-card>
      </v-row>
      <v-divider></v-divider>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "education",
  created() {
    window.addEventListener("resize", this.cal_window);
  },
  destroyed() {
    window.removeEventListener("resize", this.cal_window);
  },
  mounted() {
    this.cal_window();
  },
  methods: {
    cal_window() {
      this.isSmall = window.innerWidth < 1264 ? true : false;
      this.isExSmall = window.innerWidth < 600 ? true : false;
    },
  },
  data: () => ({
    main_icon: "mdi-school",
    bg_color: "white",
    theme_color: "teal darken-2",
    theme_text_color: "teal--text text--darken-2",
    isSmall: false,
    isExSmall: false,
    edu: [
      {
        name: "Georgia Institute of Technology",
        degree: "M.S. of Computer Science",
        date: "2019 - 2021",
        img: require("@/assets/gatech.png"),
      },
      {
        name: "Clarkson University",
        degree: "Ph.D. of Civil and Environmental Engineering",
        date: "2014 - 2018",
        img: require("@/assets/clarkson.png"),
      },
      {
        name: "Tongji University",
        degree: "M.S. of Agricultural Engineering",
        date: "2011 - 2014",
        img: require("@/assets/tongji.png"),
      },
      {
        name: "Fuzhou University",
        degree: "B.S. of Water Supply and Sewage Engineering",
        date: "2007 - 2011",
        img: require("@/assets/fuzhou.png"),
      },
    ],
  }),
};
</script>
<style scoped>
/* div {
  outline: 1px dashed blue;
} */
</style>